import { ChangeDetectionStrategy, Component, effect, inject, signal, untracked } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { TranslocoDirective } from '@jsverse/transloco';
import { interval } from 'rxjs';

import { AdvertisementHotspotComponent } from '../advertisements/advertisement-hotspot/advertisement-hotspot.component';
import { AdvertisementSuggestionsService } from '../advertisements/advertisement-suggestions.service';
import AdvertisementsCarouselComponent from '../advertisements/advertisements-carousel/advertisements-carousel.component';
import { AdvertisementListItemDto } from '../api';
import { HomeNewsComponent } from '../news/home-news/home-news.component';
import { CachedCategoriesService } from '../shared/cached-categories.service';
import { NewsletterBlockComponent } from '../shared/components/newsletter-block/newsletter-block.component';
import { ProgressBarComponent } from '../shared/progress-bar/progress-bar.component';

@Component({
  selector: 'app-home',
  imports: [
    MatButton,
    MatIcon,
    TranslocoDirective,
    RouterLink,
    ProgressBarComponent,
    AdvertisementsCarouselComponent,
    AdvertisementHotspotComponent,
    NewsletterBlockComponent,
    HomeNewsComponent,
  ],
  templateUrl: 'home.component.html',
  styleUrl: 'home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class HomeComponent {
  private suggestionsService = inject(AdvertisementSuggestionsService);
  suggestions = this.suggestionsService.suggestions;
  hotspotAdvertisement = signal<AdvertisementListItemDto | null>(null);
  loading = this.suggestionsService.loading;
  categories = inject(CachedCategoriesService).categoriesMap;
  private timerSignal = toSignal(interval(5000));

  constructor() {
    effect(() => {
      // change the hotspot advertisement to the next one every 5 seconds
      this.timerSignal();
      const ads = this.suggestions()?.hotspots ?? [];
      const currentAd = untracked(() => this.hotspotAdvertisement());
      let currentAdIndex = currentAd ? ads.indexOf(currentAd) + 1 : -1;
      if (currentAdIndex === -1 || currentAdIndex === ads.length - 1) {
        currentAdIndex = 0;
      }
      this.hotspotAdvertisement.set(ads.length ? ads[currentAdIndex] : null);
    });
  }
}
